import { render } from "./AgentReports.vue?vue&type=template&id=044b24cc"
import script from "./AgentReports.vue?vue&type=script&lang=js"
export * from "./AgentReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__